'use strict';

define('vb/action/builtin/navigateBackAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Navigate back to the previous page in browser history with input parameters.
   * It executes the back() method of the browser history except when in a oj-vb-switcher component.
   *
   * In a switcher component, the browser back() method can switch back to the previous tab. This behavior
   * is not always desired, so the navigateBackAction is acting differently, it goes back to the previous page
   * in that tab.
   *
   * @extends Action
   * @category Action
   */
  class NavigateBackAction extends Action {
    /**
     * Performs the navigation back action by calling the navigateBack helper function.
     *
     * @param {Object} [parameters]
     * @param {Object} [parameters.params] - The input parameters for the page
     * the action is going back to
     * @returns {Promise<Outcome>} A promise that resolves with an outcome object indicating success or failure.
     *                           The outcome object has a 'success' property set to true if the operation was
     *                           successful, or a 'failure' property with an error message if the operation failed.
     */
    perform(parameters) {
      return this.helpers.navigateBack(parameters)
        .then(() => Action.createSuccessOutcome())
        .catch((e) => Action.createFailureOutcome('Error during navigateBackAction', e));
    }
  }

  return NavigateBackAction;
});

